import { useSelector } from 'react-redux';

import { isRdp } from '../utilities';

const useRdpDownloadEnabled = (data) => {
  const { isNativeRdpEnabled = '' } =
    useSelector((state) => state.user?.nativeRDPconfig) || {};
  const enableNativeRdp = useSelector(
    (state) => state.user?.domainInfo?.ENABLE_NATIVE_RDP
  );

  const isEnabled = isNativeRdpEnabled === '1' && !!enableNativeRdp;
  const isAdServer =
    isRdp(data?.remoteAppMetadata) && data?.pamPlatformType === 'ADConsole';
  const isCredentialless = data?.pamType?.toUpperCase() === 'CREDENTIALLESS';
  const isWindows = data?.pamPlatformType?.toLowerCase() === 'windows';
  const shouldShowDownload =
    isEnabled && isCredentialless && (isAdServer || isWindows);

  return {
    isRdpDownloadEnabled: isEnabled,
    isAdServer,
    isCredentialless,
    isWindows,
    shouldShowDownload,
  };
};

export default useRdpDownloadEnabled;
